import React, { Component,useEffect,useState } from "react";
import CalendarTable from "./calendartable";
import { Link } from 'react-router-dom';

class Calendar extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="calendar" className="a-breadcrumbs">ปฏิทินสหกรณ์</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
          <div className="container">
            <div className="row">
              

              <CalendarTable />

            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Calendar;
